// src/App.js
import React from 'react';
import CouponRedemption from './CouponRedemption';

function App() {
  return (
    <div className="App">
      <CouponRedemption />
    </div>
  );
}

export default App;
